<template>
  <b-modal
    id="assessexpired"
    centered
    hide-footer
    hide-header
    :visible="showExpired"
    no-close-on-backdrop
    @hidden="closeCancelModal()"
  >
    <div class="w-100">
      <div class="d-flex">
        <img
          class="mb-3"
          src="../../../assets/img/newkanban/infopop.svg"
          alt=""
        />
        <div class="w-100 mt-2 ml-2">
          <div class="d-flex justify-content-between">
            <div class="pff-modal-heading">
              The configuration has been expired
            </div>
            <div class="pointer" @click="closeCancelModal()">
              <img
                class="rotate-on-hover"
                src="../../../assets/img/feedbackform/x-close.svg"
                alt=""
              />
            </div>
          </div>
          <div class="mt-2 cancelmeeting-subheads">
            Please reach out to the creator of the job to change the
            configuartion
          </div>
        </div>
      </div>

      <div
        class="
          d-flex
          align-items-center
          justify-content-end
          p-2
          bluebtn
          mt-2
          mb-2
        "
      >
        <b-button
          class="acs-cancelBtn-modal w-105px mr-3"
          @click="closeCancelModal()"
          >Cancel</b-button
        >
        <div class="position-relative">
          <b-button
            class="acs-addBtn-modal w-105px"
            @click="sendNotification()"
            :class="
              showSpinner ? 'upload-loader-class defaultCursor' : 'pointer'
            "
            >{{ showSpinner ? "" : "Send Notification" }}</b-button
          >
          <div v-if="showSpinner" class="send-loader-pos">
            <Loader />
          </div>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import { mapGetters } from "vuex";
import toast from "../../mixin/toast";
import Loader from "../../../components/fixedcomponents/Loader.vue";
import { sendConfExpiredNoitification } from "../../../utils/apiFunctions";
export default {
  name: "AssessmentExpired",
  props: {
    jobID: String,
    showExpired: Boolean,
  },
  data() {
    return {
      showSpinner: false,
      ScheduleInterview: {},
    };
  },
  computed: {
    ...mapGetters("userVUEX", {
      roleValues: "getRoleValues",
    }),
  },
  components: {
    Loader,
  },
  mixins: [toast],
  methods: {
    closeCancelModal() {
      this.$emit("close-expired");
    },
    async sendNotification() {
      this.showSpinner = true;
      try {
        let payload = {
          jobID: this.jobID,
        };
        const res = await sendConfExpiredNoitification(payload);
        if (res.status === 200) {
          this.showSpinner = false;
          this.dynamicToast(
            "success",
            `Successfully sent`,
            "Notification sent successfully"
          );
          this.closeCancelModal();
        } else {
          this.showSpinner = false;
          this.errorModal("Something went wrong!");
        }
      } catch (err) {
        this.showSpinner = false;
        this.errorModal("Something went wrong!");
      }
    },
  },
};
</script>

<style scoped>
.upload-loader-class {
  opacity: 0.5;
  height: 30px;
  width: 160px;
}

.send-loader-pos {
  position: absolute;
  top: -54px;
  z-index: 1;
  left: 30px;
}
</style>
